import {Card, CardContent, CardHeader} from "@mui/material";
import {Solicitation} from "../../../types/solicitation/solicitationData";
import {
    SolicitationFinancePreferences
} from "../../../types/financing/financingData";
import {Client} from "../../../types/client/clientData";
import {useContext, useEffect, useState} from "react";
import {HttpClient} from "../../../http/client/httpClient";
import {CompanyContext, CompanyContextValue} from "../../solicitation-new/context/companyContext";
import {LoaderBlockUI} from "../../../components/loader";
import SolicitationCompanyDataDetail from "./components/summary/SolicitationCompanyDataDetail";
import SolicitationFinancePreferencesData from "./components/summary/SolicitationFinancePreferencesData";
import SolicitationSummaryTablesData from "./components/summary/SolicitationSummaryTablesData";

interface SolicitationSummaryTabProps {
    solicitation: Solicitation,
    preferences: SolicitationFinancePreferences
}

const SolicitationSummaryTab = ({solicitation, preferences}: SolicitationSummaryTabProps) => {
    const [client, setClient] = useState<Client>()
    const [loading, setLoading] = useState<boolean>(false)
    const {clientId} = useContext<CompanyContextValue>(CompanyContext)
    
    
    useEffect(() => {
        setLoading(true)
        HttpClient.getById(clientId).then((r) => {
            setLoading(false)
            setClient(r)
        })
    }, [clientId])
    
    return (
        !loading || client ?
            <Card>
                <CardHeader title={'Resumen'}/>
                <CardContent>
                    <SolicitationCompanyDataDetail client={client} solicitation={solicitation}/>
                    <SolicitationFinancePreferencesData preferences={preferences} />
                    <SolicitationSummaryTablesData solicitation={solicitation} client={client}/>
                </CardContent>
            </Card>
            :
            <LoaderBlockUI />
        
    )
}

export default SolicitationSummaryTab